import { render, staticRenderFns } from "./recentChats.vue?vue&type=template&id=87b9ce02"
import script from "./recentChats.vue?vue&type=script&lang=js"
export * from "./recentChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports